import { IState } from '../../store';

export const selectAsideCompactMode = (state: IState): boolean => {
  return state.aside.isCompactModeEnabled;
};
